import React, { useMemo } from "react";
import classNames from "classnames";
import { Accept, DropzoneOptions, useDropzone } from "react-dropzone";

import styles from './style.module.scss';
import Conditional from "../../common/conditional";

interface Props extends DropzoneOptions {
    files: File[];
    accept: Accept;
    onRemoveFile: (file: File) => void;
}

const FileImport: React.FC<Props> = (props) => {
    const { getRootProps, getInputProps, isDragActive } = useDropzone(props);

    const acceptableFileFormats = useMemo(() => {
        return Object.values(props.accept).join(', ');
    }, [props.accept]);

    return ( 
        <div className={styles.container}>
            <h3>Upload</h3>

            <div {...getRootProps({ className: styles.content })}>
                <input {...getInputProps()} />
                
                <div className={classNames({
                    "d-flex justify-content-center": true,
                    [styles.icon]: true
                })}>
                    <i className="bi bi-cloud-upload"></i>
                </div>

                <p className={styles.label}>
                    {isDragActive ? 'Drop the files here' : <>Drag & drop files or <button type="button">Browse</button></>}
                </p>

                <p className={styles.format}>
                    Supported Formats: {acceptableFileFormats}
                </p>
            </div>

            <Conditional isVisible={props.files.length > 0}>
                <div className={styles.uploads}>
                    <h4>Uploaded</h4>

                    {props.files.map((file) => (
                        <div key={file.name} className={classNames(["d-flex justify-content-start align-items-center", styles.upload])}>
                            <p className="flex-fill m-0">{file.name}</p>
                            <button onClick={() => props.onRemoveFile(file)}><i className="bi bi-trash"></i></button>
                        </div>
                    ))}
                </div>
            </Conditional>
        </div>
     );
};
 
export default FileImport;